module.exports = __webpack_public_path__ + "img/2H.29579caa.png";